import { UserRolesEnum } from "./pages/auth/userRoles.enum";
import {
   GroupPeople,
   Assessments,
   DocumentHandHeldWriting,
   DashboardWorkspace,
   Requests,
   Organizations,
   GroupPeopleInactive,
   DocumentHandHeldWritingActive,
   DashboardWorkspaceActive,
   AssessmentsActive,
   RequestsActive,
   OrganizationsActive,
   TargetsIconActive,
   TargetsIcon
} from "./assets/icons";
import AuthService from "./base/services/authentication.service";
export const mainMenu = {
   layout: [
      {
         id: "assessments",
         title: "Assessments",
         role: [
            UserRolesEnum.Manager,
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.Consultant
         ],
         type: "list",
         children: [
            {
               id: "self-assessments",
               title: "Self assessments",
               type: "route",
               link: "/assesment/self-assessment/",
               kind: "self-assessment",
               api: "/assesment/self-assessment/",
               url: "/workspace/assessment/self-assessment/",
               icon: "selfAssessment.svg",
               role: [
                  UserRolesEnum.Manager,
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.InternationalOrganization
               ]
            },
            {
               id: "guided-assessment",
               title: "Guided assessments",
               type: "route",
               link: "/assesment/guided-assessment/",
               kind: "guided-assessment",
               api: "/assesment/guided-assessment/",
               url: "/workspace/assessment/guided-assessment/",
               icon: "guided.svg",
               role: [
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.InternationalOrganization,
                  UserRolesEnum.Consultant
               ]
            },
            {
               id: "survey-request",
               title: "Module Request",
               type: "route",
               link: "/action-plan",
               api: "/assessment/action-plan/list",
               kind: "survey-request",
               icon: "surveyRequest.svg",
               url: "/workspace/survey-request/",
               role: [UserRolesEnum.Manager]
            },
         ]
      },
      {
         id: "results",
         title: "Results",
         role: [
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.Manager,
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Donor,
            UserRolesEnum.Staff,
            UserRolesEnum.Consultant
         ],
         type: "list",
         children: [
            {
               id: "results",
               title: "Results",
               type: "route",
               link: "/api/test/123",
               icon: "results.svg",
               kind: "results",
               api: "/api/test/123",
               url: "/workspace/results/results",
               adminUrl: "/workspace/results/results",
               redirect: true,
               role: [
                  UserRolesEnum.InternationalOrganization,
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.SuperAdmin,
                  UserRolesEnum.Donor,
                  UserRolesEnum.Consultant,
                  UserRolesEnum.Manager
               ],
               adminRole: [
                  UserRolesEnum.SuperAdmin,
                  UserRolesEnum.Donor,
                  UserRolesEnum.InternationalOrganization,
                  UserRolesEnum.Consultant
               ]
            },
            {
               id: "action-plan",
               title: "Action plan",
               type: "route",
               link: "/action-plan",
               api: "/assessment/action-plan/list",
               kind: "action-plan",
               icon: "action.svg",
               url: "/workspace/results/action-plan/",
               // url: AuthService.isAuthorized([UserRolesEnum.Staff])
               //    ? "/workspace/results/action-plan-member/"
               //    : "/workspace/results/action-plan/",
               role: [
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.SuperAdmin,
                  // UserRolesEnum.Consultant,
                  UserRolesEnum.Manager
                  // UserRolesEnum.Staff
               ]
            },
            {
               id: "my-performance",
               title: "My performance",
               type: "route",
               link: "/workspace/myperformance",
               api: "/assessment/action-plan/list",
               kind: "my-performance",
               icon: "action.svg",
               url: "/workspace/my-performance",
               role: [UserRolesEnum.Staff]
            },
            {
               id: "task-management",
               title: "Task management",
               type: "route",
               link: "/workspace/task-management",
               api: "/assessment/action-plan/list",
               kind: "task-management",
               icon: "action.svg",
               url: "/workspace/task-management",
               role: [UserRolesEnum.Staff]
            },
            {
               id: "survey-request",
               title: "Resources",
               type: "route",
               link: "/resources",
               api: "/assessment/action-plan/list",
               kind: "survey-request",
               icon: "action.svg",
               url: "/workspace/resources",
               role: [
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.SuperAdmin,
                  UserRolesEnum.Manager,
                  UserRolesEnum.Staff
               ]
            }
         ]
      },
      {
         id: "organizations",
         title: "Organizations",
         role: [
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Donor
         ],
         type: "banner",
         children: [
            {
               id: "organization-management",
               title: "Organization management",
               type: "banner",
               link: "/workspace/organization-management",
               icon: "Illustration.svg",
               role: [
                  UserRolesEnum.InternationalOrganization,
                  UserRolesEnum.NationalOrganization,
                  UserRolesEnum.Manager,
                  UserRolesEnum.SuperAdmin,
                  UserRolesEnum.Donor
               ]
            }
         ]
      }
   ],
   adminLayout: [
      {
         id: "admin_page_01234",
         title: "Team management",
         type: "module",
         icons: { active: GroupPeople, inactive: GroupPeopleInactive },
         url: "/admin/teams",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      },
      {
         id: "admin_page_0123344",
         title: "Assessments",
         type: "module",
         icons: { active: AssessmentsActive, inactive: Assessments },
         url: "/admin/assessment",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      },
      {
         id: "admin_page_0122",
         title: "Modules",
         type: "module",
         icons: { active: DocumentHandHeldWritingActive, inactive: DocumentHandHeldWriting },
         url: "/admin/module",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      },
      {
         id: "admin_page_01235",
         title: "Targets",
         type: "module",
         icons: { active: TargetsIconActive, inactive: TargetsIcon },
         url: "/admin/targets",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      },
      {
         id: "admin_page_011",
         title: "Workspaces",
         type: "module",
         icons: { active: DashboardWorkspaceActive, inactive: DashboardWorkspace },
         url: "/admin/workspace",
         role: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.Staff
         ],
         subMenus: []
      },
      {
         id: "admin_page_01211233",
         title: "Requests",
         type: "module",
         icons: { active: RequestsActive, inactive: Requests },
         url: "/admin/request",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      },
      {
         id: "admin_page_0123435",
         title: "Organizations",
         type: "module",
         icons: { active: OrganizationsActive, inactive: Organizations },
         url: "/admin/organization",
         role: [UserRolesEnum.SuperAdmin],
         subMenus: []
      }
   ]
};

// mainMenu.layout section/item titles are stored in English so ids stay stable
// regardless of locale — this lookup translates that display text at the point
// each consumer renders it. Keyed by title text rather than id since the
// "survey-request" id is reused for two different titles ("Module Request"
// under Assessments, "Resources" under Results).
const MENU_TITLE_TRANSLATION_KEYS = {
   Assessments: "menu-item-assessments",
   "Self assessments": "self-assessments-menu-item",
   "Guided assessments": "guided-assessments-menu-item",
   "Module Request": "module-request-menu-item",
   Results: "results-word",
   "Action plan": "action-plan-menu-item",
   "My performance": "my-performance-menu-item",
   "Task management": "task-management-menu-item",
   Resources: "resources-menu-item",
   Organizations: "menu-item-organizations",
   "Organization management": "organization-management-menu-item"
};

export const translateMenuTitle = (title, t) => {
   const translationKey = MENU_TITLE_TRANSLATION_KEYS[title];
   return translationKey ? t(translationKey) : title;
};
